<template>
    <TopNav></TopNav>
		<h1>Tangent Calculator</h1>
		<fieldset>
      <legend>Tangent Calculator</legend>
      <label for="de" class="leftLabel">Degree:</label> <input type="number" v-model.number="degree" step="any" @input="onDegreeChange" autofocus id="de"> <label for="de">°</label>
			<br>
      <label for="ta" class="leftLabel">Result:</label> <input type="number" v-model.number="tangent" step="any" @input="onTangentChange" id="ta">
      <br><br>
      tan({{ degree }}°) = <span class="blue">{{ tangent }}</span>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Tangent",
  data() {
    return {
      degree: 0,
      tangent: 0
    }
  },
  components: {
    TopNav
  },
  methods: {
    onDegreeChange(e) {
      const formatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 4
      });

      const degree = e.currentTarget.value;
      const degreeNumber = Number(degree);
      const tangent = Math.tan(degreeNumber * Math.PI / 180);
      const tangentNumber = Number(tangent);
      this.tangent = formatter.format(tangentNumber);
    },
    onTangentChange(e) {
      const formatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 4
      });

      const tangent = e.currentTarget.value;
      const tangentNumber = Number(tangent);
      const degree = Math.atan(tangentNumber) * (180 / Math.PI);
      const degreeNumber = Number(degree);
      this.degree = formatter.format(degreeNumber);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label.leftLabel {
  display: inline-block;
  width: 90px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
